export class TestedServer{
    constructor(hostName, hostUrl, hostPort) {
        this.hostName = hostName;
        this.hostUrl = hostUrl;
        this.hostPort = hostPort;
    }
}

//hostname 
//port
//URL